export const WORKLOG_TIMER_STATE = {
  stopped: 'STOPPED',
  running: 'RUNNING',
  inited: 'INITED',
  paused: 'PAUSED'
};

export const WORKLOG_ITEM_STATE = {
  pending: 'PENDING',
  approved: 'APPROVED',
  ignored: 'IGNORED',
  invoiced: 'INVOICED',
  UNDER_CONTRACT: 'UNDER_CONTRACT'
};
